import apiService from '@/services/apiService';

const actions = {
  getOnlineTest({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('px/online-test')
        .then((response) => {
          resolve(response);
          commit('getOnlineTest', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getOnlineTestId({ commit }, payload) {
    apiService.get(`px/online-test/${payload}`)
      .then((response) => {
        commit('getOnlineTestId', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postOnlineTest({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('px/online-test', payload)
        .then((response) => {
          commit('postOnlineTest', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putOnlineTest({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`px/online-test/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putOnlineTest', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delOnlineTest({ commit }, payload) {
    apiService.delete(`px/online-test/${payload}`)
      .then((response) => {
        commit('delOnlineTest', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

export default actions;
